import React, { useRef, useEffect } from 'react';
import { ReactEditor, Editable, Slate, withReact, useSlate } from 'nifty-slate-react';
import { Editor, Range, createEditor, Transforms } from 'slate';

import BodyPortal from '../portals/body-portal';

import IconFormatBold from '../icons/icon-format-bold';
import IconFormatItalic from '../icons/icon-format-italic';
import IconFormatUnorderedList from '../icons/icon-format-unordered-list';
import IconFormatCode from '../icons/icon-format-code';

const Button = ({ action, onClick, children }) => {
    const handleClick = event => {
        event.preventDefault();

        onClick && onClick(action);
    }

    return (
        <button onMouseDown={handleClick}>
            {children}
        </button>
    );
};

const EditorHoverMenu = ({ onClick }) => {
    const ref = useRef()
    const editor = useSlate()

    useEffect(() => {
        const el = ref.current
        const { selection } = editor

        if (!el) {
            return
        }

        if (
            !selection ||
            !ReactEditor.isFocused(editor) ||
            Range.isCollapsed(selection) ||
            Editor.string(editor, selection) === ''
        ) {
            el.removeAttribute('style')
            return
        }

        const domSelection = window.getSelection()
        const domRange = domSelection.getRangeAt(0)
        const rect = domRange.getBoundingClientRect()
        el.style.opacity = 1
        el.style.top = `${rect.top + window.pageYOffset - el.offsetHeight}px`
        el.style.left = `${rect.left +
            window.pageXOffset -
            el.offsetWidth / 2 +
            rect.width / 2}px`
    })

    return (
        <BodyPortal>
            <div className="input-text-editor-menu" ref={ref}>
                <Button action="bold" onClick={onClick}><IconFormatBold /></Button>

                <Button action="italic" onClick={onClick}><IconFormatItalic /></Button>

                <Button action="unorderedList" onClick={onClick}><IconFormatUnorderedList /></Button>

                <Button action="code" onClick={onClick}><IconFormatCode /></Button>
            </div>
        </BodyPortal>
    );
}

export default EditorHoverMenu;
